
import { defineComponent } from "vue";
import { Todo } from "../types/Todo";
import Item from "./Item.vue";
export default defineComponent({
    name: "List",
    props: {
        todos: {
            type: Array as () => Todo[],
        },
    },
    components: {
        Item,
    },
});
